export default __webpack_public_path__ + "static/media/apple_iphone_12.e012a8a0.jpg";